import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Skeleton } from "@mui/material";

import { BaseUrlCore, fileApi, simReportApi } from "../../../utility/api/apiList";

import {
  closeAlert,
  showInfoAlert,
} from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";

import ActivityTabContainer from "../activityTab";
import LabReport from "../../../components/public/singleSimTabs/labReport";
import ButtonComponent from "../../../components/public/button";


import {
  UploadImageSkeleton,
  SkeletonWrapper,
  ActivityButton,
  StyledContainer,
} from "../../../components/public/singleSimTabs/labReport/styledLabReport";
import { TabContentSection } from "../styledSimContainer";

export const editorContent = (data) => {
  return [
    {
      id: 1,
      name: "content",
      label: "برای آماده‌سازی آزمایش چه کارهایی انجام دادی؟ ",
      value: data?.content ? data.content : "",
    },
    {
      id: 2,
      name: "observation",
      label: "از انجام آزمایش چه مشاهداتی داشتی؟",
      value: data?.observation ? data.observation : "",
    },
    {
      id: 3,
      name: "conclusion",
      label: "با مقایسه‌ی مشاهدات چه نتایجی گرفتی؟",
      value: data?.conclusion ? data.conclusion : "",
    },
  ];
};

const LabReportTabContainer = () => {
  const [uploaderImageArray, setUploaderImageArray] = useState([]);
  const [labReportSection, setLabReportSection] = useState(true);
  const isLogin = useSelector((state) => state.userDetail.isLogin);
  const dispatch = useDispatch();
  const location = useLocation();

  const { id } = useParams();

  const {
    data: simReportData,
    isLoaded: simReportLoaded,
    error: simReportError,
    run: simReportRun,
  } = useAxios({
    url: simReportApi,
    params: {
      sim_id: id,
    },
  });

  const { isLoading: postLabReportLoading, run: postLabReportRun } = useAxios({
    url: simReportApi,
    method: "post",
  });

  const { isLoading: putLabReportLoading, run: putLabReportRun } = useAxios({
    baseURL: BaseUrlCore,
    method: "put",
  });

  const {
    data: file,
    isLoading: uploadImageLoading,
    run: uploadImageRun,
  } = useAxios({
    url: fileApi,
    method: "post",
    showError: true,
    errorMessage: "آپلود عکس با خطا مواجه شد.",
  });

  const { run: deleteImage } = useAxios({
    method: "delete",
    showError: true,
    errorMessage: "حذف عکس با خطا مواجه شد.",
  });

  useEffect(() => {
    if (!isLogin) {
      dispatch(showInfoAlert("لطفا ابتدا وارد سایت شوید."));
      setTimeout(() => {
        dispatch(closeAlert());
      }, 6000);
    } else {
      if (location.state?.editFromProfile) setLabReportSection(false);
      simReportRun();
    }
  }, []);

  useEffect(() => {
    let array = [];
    const list = simReportData?.image.map((imageData) =>
      array.push({
        id: imageData.id,
        src: imageData.src,
        is_uploaded_server: true,
      })
    );
    setUploaderImageArray(array);
  }, [simReportData?.image]);

  const editorData = editorContent(simReportData);

  const LabReportSkeleton = () => {
    return (
      <StyledContainer className="mx-auto p-0 d-flex flex-column align-items-start">
        <ActivityButton
          className="mx-2 mx-md-0 mb-1 mb-md-0 align-self-md-end"
          $smallButton={true}
        >
          گزارش فعالیت شما
        </ActivityButton>
        <SkeletonWrapper className="w-100">
          {editorData.map((item) => (
            <Skeleton key={item.id} className="skeleton" />
          ))}
          <UploadImageSkeleton />
          <ButtonComponent
            type="submit"
            className="submit-button mt-3 d-block mx-auto"
          >
            ثبت گزارش
          </ButtonComponent>
        </SkeletonWrapper>
      </StyledContainer>
    );
  };

  let element = null;
  if (simReportError) {
    element = <p className="text-center">{simReportError.detail}</p>;
  } else if (!simReportLoaded) {
    element = <LabReportSkeleton />;
  } else {
    element = labReportSection ? (
      <LabReport
        simID={id}
        isLogin={isLogin}
        editorContent={editorData}
        file={file}
        uploadedImages={uploaderImageArray}
        simReportData={simReportData}
        setLabReportSection={setLabReportSection}
        updateData={{
          simReportRun,
          postLabReportRun,
          putLabReportRun,
          uploadImageRun,
          deleteImage,
        }}
        loading={{
          simReportLoaded,
          uploadImageLoading,
          postLabReportLoading,
          putLabReportLoading,
        }}
      />
    ) : (
      <ActivityTabContainer
        simID={id}
        editorContent={editorData}
        simReportData={simReportData}
        uploaderImageArray={uploaderImageArray}
        setLabReportSection={setLabReportSection}
        isLoaded={simReportLoaded}
      />
    );
  }
  return <TabContentSection className="py-4 px-md-3">{element}</TabContentSection>;
};

export default LabReportTabContainer;
